/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import MaskedInput from "react-maskedinput";
import { CircularProgress } from "@material-ui/core";
import { getRequest, putRequest, postRequest } from "utils/request";

import { i18n } from "../../../translate/i18n";

import "./style.css";
import { useModal } from "hooks/modal";
import { useAuth } from "hooks/auth";
import { tzList } from "utils/timezoneList";
import Swal from "sweetalert2";

export default function NewUsers({ match, history }) {
  const [loading, setLoading] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [name, setName] = useState("");
  const [nickName, setNickName] = useState("");
  const [email, setEmail] = useState("");
  const [login, setLogin] = useState("");
  const [document, setDocument] = useState("");
  const [password, setPassword] = useState("");
  const [UserTypeID, setUserTypeID] = useState("");
  const [originalUserTypeID, setOriginalUserTypeID] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [language, setLanguage] = useState("");
  const [active, setActive] = useState(true);
  const [ldapAuth, setLdapAuth] = useState(false);
  const [ldapAuthDb, setLdapAuthDb] = useState(false);
  const [specialPermition, setSpecialPermition] = useState(false);
  const [allowForwardTicket, setAllowForwardTicket] = useState(false);
  const [onlyManualAttribution, setOnlyManualAttribution] = useState(false);
  const [allowAssumeTicket, setAllowAssumeTicket] = useState(false);
  const { toggleHelperId } = useModal();
  const { setUserIdChangePassword, setChangePassword } = useAuth();
  // const { selectedCompany } = useNotification();

  const getProfiles = async () => {
    setLoading(true);

    //BUSCA PERFIS DISPONIVEIS
    const returnGet = await getRequest("/userstypes");
    if (returnGet) {
      setUserTypes(returnGet.data);
    }

    //BUSCA DADOS DO USUÁRIO
    if (match.params.id) {
      setLoading(true);

      const ReturnGet3 = await getRequest(`/users/${match.params.id}`);
      if (ReturnGet3.success) {
        setName(ReturnGet3.data.name);
        setNickName(ReturnGet3.data.nickName);
        setLogin(ReturnGet3.data.login);
        setEmail(ReturnGet3.data.email);
        setDocument(ReturnGet3.data.document);
        setUserTypeID(ReturnGet3.data.UserTypeId);
        setOriginalUserTypeID(ReturnGet3.data.UserTypeId);
        setLanguage(ReturnGet3.data.language);
        setActive(ReturnGet3.data.active);
        setTimeZone(ReturnGet3.data.timeZone);

        if (
          ReturnGet3.data.UserTypeId === 14 ||
          ReturnGet3.data.UserTypeId === 15
        ) {
          setSpecialPermition(true);
        }

        if (ReturnGet3.data.onlyManualAttribution) {
          setOnlyManualAttribution(true);
        }

        if (ReturnGet3.data.allowForwardTicket) {
          setAllowForwardTicket(true);
        }

        if (ReturnGet3.data.allowAssumeTickets) {
          setAllowAssumeTicket(true);
        }

        if (!ReturnGet3.data.passwordHash) {
          setLdapAuth(true);
          setLdapAuthDb(true);
        }
      }
    }
    setLoading(false);
  };

  const changePassword = () => {
    setChangePassword(true);
    setUserIdChangePassword(match.params.id);
    history.push(`../../dashboard/changepassword/`);
  };

  const manageUserCompany = () => {
    history.push(`../usercompany/${match.params.id}`);
  };

  const handleConfirm = async () => {
    if (match.params.id) {
      const user = {
        name: name,
        login: login,
        nickName: nickName,
        email: email,
        document: document,
        UserTypeId: Number(UserTypeID),
        language: language,
        timeZone,
        ldapAuth,
        password,
        allowForwardTicket:
          Number(UserTypeID !== 14) ||
          Number(UserTypeID !== 15) ||
          Number(UserTypeID !== 4) ||
          Number(UserTypeID !== 10)
            ? allowForwardTicket
            : true,
        onlyManualAttribution:
          Number(UserTypeID !== 14) ||
          Number(UserTypeID !== 15) ||
          Number(UserTypeID !== 4) ||
          Number(UserTypeID !== 10)
            ? onlyManualAttribution
            : true,
        allowAssumeTickets:
          Number(UserTypeID !== 14) ||
          Number(UserTypeID !== 15) ||
          Number(UserTypeID !== 4) ||
          Number(UserTypeID !== 10)
            ? allowAssumeTicket
            : false,
      };

      if (
        originalUserTypeID !== Number(UserTypeID) &&
        (Number(originalUserTypeID) !== 10 || Number(UserTypeID) !== 14) &&
        (Number(originalUserTypeID) !== 14 || Number(UserTypeID) !== 10) &&
        (Number(originalUserTypeID) !== 15 || Number(UserTypeID) !== 4) &&
        (Number(originalUserTypeID) !== 4 || Number(UserTypeID) !== 15)
      ) {
        await Swal.fire({
          title: i18n.t("confirmChangeUserProfile"),
          text: i18n.t("changeUserProfile"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: i18n.t("confirm"),
          cancelButtonText: i18n.t("cancel"),
        }).then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            //SALVA ALTERAÇÕES DO USUÁRIO
            const ReturnPut = await putRequest(
              `/users/staff/${match.params.id}`,
              user
            );
            setLoading(true);
            if (ReturnPut.success) {
              history.push(`../../dashboard/user`);
            }
            setLoading(false);
          } else {
            return;
          }
        });
      } else {
        setLoading(true);
        //SALVA ALTERAÇÕES DO USUÁRIO
        const ReturnPut = await putRequest(
          `/users/staff/${match.params.id}`,
          user
        );
        setLoading(false);
        if (ReturnPut.success) {
          history.push(`../../dashboard/user`);
        }
      }
    } else {
      setLoading(true);

      const newUser = {
        name: name,
        login: login,
        nickName: nickName,
        password: ldapAuth ? null : password,
        email: email,
        document: document,
        UserTypeId: Number(UserTypeID),
        language: language,
        timeZone,
        allowForwardTicket:
          Number(UserTypeID !== 14) ||
          Number(UserTypeID !== 15) ||
          Number(UserTypeID !== 4) ||
          Number(UserTypeID !== 10)
            ? allowForwardTicket
            : true,
        onlyManualAttribution:
          Number(UserTypeID !== 14) ||
          Number(UserTypeID !== 15) ||
          Number(UserTypeID !== 4) ||
          Number(UserTypeID !== 10)
            ? onlyManualAttribution
            : true,
      };

      //SALVA NOVO USUÁRIO
      const ReturnPost = await postRequest(`/users/staff`, newUser);
      setLoading(false);
      if (ReturnPost.success) {
        history.push(`../../dashboard/newuser/${ReturnPost.data.id}`);
      }
    }
  };

  const handleChangeUserType = (e) => {
    var _userTypeID = e.target.value;

    setUserTypeID(_userTypeID);

    if (Number(_userTypeID) === 10 && specialPermition) {
      setUserTypeID("14");
    }

    if (Number(_userTypeID) === 4 && specialPermition) {
      setUserTypeID("15");
    }

    if (Number(_userTypeID) === 14 && !specialPermition) {
      setUserTypeID("10");
    }

    if (Number(_userTypeID) === 15 && !specialPermition) {
      setUserTypeID("4");
    }
  };

  const ConfigMask = (data) => {
    let value;
    value = data.replace(/([^\d])+/gim, "");
    return value;
  };

  useEffect(() => {
    getProfiles();
    toggleHelperId(21);
  }, []);

  const toggleSpecialPermission = (e) => {
    if (Number(UserTypeID) === 10 && !specialPermition) {
      setUserTypeID("14");
    }

    if (Number(UserTypeID) === 4 && !specialPermition) {
      setUserTypeID("15");
    }

    if (Number(UserTypeID) === 14 && specialPermition) {
      setUserTypeID("10");
    }

    if (Number(UserTypeID) === 15 && specialPermition) {
      setUserTypeID("4");
    }

    setSpecialPermition(!specialPermition);
  };

  return (
    <div className="col-12" style={{ overflowY: "auto" }}>
      <div className="card">
        <div className="card-body pt-1">
          {!loading ? (
            <>
              <form
                className="form-edit"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleConfirm();
                }}
              >
                <h4 className="header-title">{i18n.t("newUserHeader")}</h4>
                <div className="form-row">
                  <div className="form-group col-md-6 mt-1">
                    <label>{i18n.t("login")} *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Login"
                      maxLength={30}
                      required
                      disabled={!active}
                      value={login}
                      onChange={(value) => setLogin(value.target.value)}
                    />
                    <label style={{ marginTop: 10, width: 500 }}>
                      {i18n.t("loginSugest")}
                    </label>
                    <label style={{ width: 500 }}>
                      {i18n.t("loginExample")}
                    </label>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group col-md-3">
                    <label>{i18n.t("name")} *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Nome"
                      required
                      maxLength={100}
                      disabled={!active}
                      value={name}
                      onChange={(value) => setName(value.target.value)}
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label>{i18n.t("nickname")} *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Apelido"
                      maxLength={100}
                      disabled={!active}
                      required
                      value={nickName}
                      onChange={(value) => setNickName(value.target.value)}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-3">
                    <label>{i18n.t("document")} *</label>
                    <MaskedInput
                      mask="111.111.111-11"
                      type="text"
                      className="form-control"
                      disabled={!active}
                      data-toggle="input-mask"
                      data-mask-format="000.000.000-00"
                      data-reverse="true"
                      maxLength="14"
                      minLength="14"
                      placeholder="000.000.000-00"
                      required
                      value={document}
                      onChange={(value) =>
                        setDocument(ConfigMask(value.target.value))
                      }
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <label>{i18n.t("email")}</label>
                    <input
                      type="email"
                      id="example-email"
                      maxLength={100}
                      disabled={!active}
                      name="example-email"
                      className="form-control"
                      value={email}
                      placeholder="exemplo@exemplo.com.br"
                      onChange={(value) => setEmail(value.target.value)}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group col-md-3">
                    <label>{i18n.t("profile")} *</label>
                    <select
                      className="form-control select2"
                      data-toggle="select2"
                      disabled={!active}
                      required
                      value={
                        Number(UserTypeID) === 14
                          ? 10
                          : Number(UserTypeID) === 15
                          ? 4
                          : Number(UserTypeID)
                      }
                      onChange={handleChangeUserType}
                    >
                      <option value="">Selecione</option>
                      {userTypes.map(
                        (data, index) =>
                          data.id !== 14 &&
                          data.id !== 15 && (
                            <option key={index} value={data.id}>
                              {data.description}
                            </option>
                          )
                      )}
                    </select>
                  </div>
                </div>
                <div className="form-row">
                  {(Number(UserTypeID) === 10 ||
                    Number(UserTypeID) === 14 ||
                    Number(UserTypeID) === 15 ||
                    Number(UserTypeID) === 4) && (
                    <div className="form-row" style={{ marginLeft: 1 }}>
                      <div className="form-group col-md-3">
                        <input
                          checked={specialPermition}
                          onClick={(e) => toggleSpecialPermission(e)}
                          type="checkbox"
                          style={{ marginRight: 5, marginBottom: 1 }}
                        />
                        Permitir visualizar chamados de outros agentes
                      </div>
                      <div className="form-group col-md-3">
                        <input
                          checked={allowForwardTicket}
                          onClick={() =>
                            setAllowForwardTicket(!allowForwardTicket)
                          }
                          type="checkbox"
                          style={{ marginRight: 5, marginBottom: 1 }}
                        />
                        Permitir encaminhar chamados
                      </div>
                    </div>
                  )}

                  <div className="form-group col-md-3">
                    <input
                      checked={ldapAuth}
                      onClick={() => setLdapAuth(!ldapAuth)}
                      type="checkbox"
                      style={{ marginRight: 5, marginBottom: 1 }}
                    />
                    Autenticação por AD
                  </div>
                  {(Number(UserTypeID) === 10 ||
                    Number(UserTypeID) === 14 ||
                    Number(UserTypeID) === 15 ||
                    Number(UserTypeID) === 4) && (
                    <div className="form-group col-md-3">
                      <input
                        checked={onlyManualAttribution}
                        onClick={(e) =>
                          setOnlyManualAttribution(!onlyManualAttribution)
                        }
                        type="checkbox"
                        style={{ marginRight: 5, marginBottom: 1 }}
                      />
                      Receber apenas atribuições manuais
                    </div>
                  )}
                </div>
                {(Number(UserTypeID) === 10 ||
                  Number(UserTypeID) === 14 ||
                  Number(UserTypeID) === 15 ||
                  Number(UserTypeID) === 4) && (
                  <div className="form-row">
                    <div className="form-group col-md-3">
                      <input
                        checked={allowAssumeTicket}
                        onClick={() => setAllowAssumeTicket(!allowAssumeTicket)}
                        type="checkbox"
                        style={{ marginRight: 5, marginBottom: 1 }}
                      />
                      Assumir ticket de outros agentes
                    </div>
                  </div>
                )}
                {((!ldapAuth && !match.params.id) ||
                  (ldapAuthDb && !ldapAuth)) && (
                  <div className="form-row">
                    <div className="form-group col-md-3">
                      <label>
                        {!match.params.id
                          ? i18n.t("initialPassword")
                          : i18n.t("newPassword")}{" "}
                        *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        disabled={!active}
                        placeholder="Senha Inicial"
                        required
                        value={password}
                        onChange={(value) => setPassword(value.target.value)}
                      />
                    </div>
                  </div>
                )}
                <div className="form-row">
                  <div className="form-group col-md-3">
                    <label>{i18n.t("language")} *</label>
                    <select
                      disabled={!active}
                      value={language}
                      required
                      className="form-control select2-multiple"
                      onChange={(e) => setLanguage(e.target.value)}
                    >
                      <option value="">{i18n.t("empty")}</option>
                      <option value="pt-BR">{i18n.t("portuguese")}</option>
                      <option value="es">{i18n.t("spanish")}</option>
                    </select>
                  </div>
                  <div className="form-group col-md-3">
                    <label> {i18n.t("timeZone")} *</label>
                    <select
                      className="form-control select2"
                      data-toggle="select2"
                      value={timeZone}
                      name="timeZone"
                      required
                      onChange={(e) => setTimeZone(e.target.value)}
                    >
                      <option value="">{i18n.t("select")}</option>
                      {tzList.map((data, index) => (
                        <option key={index} value={data.value}>
                          {data.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div
                  className="button-list mt-3 pull-right"
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    marginRight: 30,
                    marginBottom: 5,
                  }}
                >
                  {match.params.id && (
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={() => manageUserCompany()}
                    >
                      <i className="mdi mdi-domain"></i>
                      {i18n.t("company")}
                    </button>
                  )}

                  {!ldapAuth && (
                    <button
                      disabled={!active}
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => changePassword()}
                    >
                      <i className="mdi mdi-textbox-password"></i>
                      {i18n.t("resetPassword")}
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={() => history.push(`../../dashboard/user`)}
                  >
                    <i className="mdi mdi-backup-restore"></i>
                    {i18n.t("getBack")}
                  </button>
                  <button
                    type="submit"
                    className="btn btn-outline-success"
                    disabled={!active}
                  >
                    <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                    {i18n.t("save")}
                  </button>
                </div>
              </form>
            </>
          ) : (
            <div className="area-loading">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
